<div class="profile-container">
  @if (!isSmeUser) {
    <div
      class="profile-tabs"
      [attr.data-active]="activeTab"
      [class.remove-border]="isSmeUser"
    >
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'my-profile'"
        (click)="onTabChange('my-profile')"
        id="tour-my-profile-tab"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          class="tab-icon"
        >
          <path
            d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4z"
          />
        </svg>
        <span>My Profile</span>
      </button>
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'cdfi-profile'"
        (click)="onTabChange('cdfi-profile')"
        id="tour-cdfi-profile-tab"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
          class="tab-icon"
        >
          <path
            d="M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"
          />
        </svg>
        <span>Organization Profile</span>
      </button>
    </div>
  }

  @if (activeTab === "my-profile") {
    <div class="profile-card">
      <div class="profile-header">
        <div class="profile-left">
          <div
            class="avatar-wrapper"
            (appClickOutside)="closeProfileDropdown()"
          >
            <div
              class="profile-avatar"
              [class.no-image]="(profileImageUrl$ | async) === null"
              id="tour-profile-upload"
            >
              @if (profileImageUrl$ | async; as imageUrl) {
                <img [src]="imageUrl" alt="Profile" class="profile-img" />
              } @else {
                {{ proPic }}
              }
            </div>

            <button
              class="avatar-edit-button"
              (click)="onIconClick(fileInput)"
              (keyup.enter)="onIconClick(fileInput)"
              tabindex="0"
              aria-label="Change profile picture"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z"
                  fill="currentColor"
                />
              </svg>
            </button>

            @if (isProfileDropdownOpen && (profileImageUrl$ | async)) {
              <div class="profile-dropdown">
                <ul>
                  <li
                    (click)="fileInput.click()"
                    (keyup.enter)="fileInput.click()"
                    tabindex="0"
                    role="button"
                  >
                    Change Picture
                    <span class="icon">
                      <svg
                        width="15"
                        height="15"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                      >
                        <path
                          d="M160 144C151.2 144 144 151.2 144 160L144 480C144 488.8 151.2 496 160 496L480 496C488.8 496 496 488.8 496 480L496 160C496 151.2 488.8 144 480 144L160 144zM96 160C96 124.7 124.7 96 160 96L480 96C515.3 96 544 124.7 544 160L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160zM224 192C241.7 192 256 206.3 256 224C256 241.7 241.7 256 224 256C206.3 256 192 241.7 192 224C192 206.3 206.3 192 224 192zM360 264C368.5 264 376.4 268.5 380.7 275.8L460.7 411.8C465.1 419.2 465.1 428.4 460.8 435.9C456.5 443.4 448.6 448 440 448L200 448C191.1 448 182.8 443 178.7 435.1C174.6 427.2 175.2 417.6 180.3 410.3L236.3 330.3C240.8 323.9 248.1 320.1 256 320.1C263.9 320.1 271.2 323.9 275.7 330.3L292.9 354.9L339.4 275.9C343.7 268.6 351.6 264.1 360.1 264.1z"
                        />
                      </svg>
                    </span>
                  </li>
                  @if (profileImageUrl$ | async) {
                    <li
                      (click)="deleteProfileImage()"
                      (keyup.enter)="deleteProfileImage()"
                      class="danger"
                      tabindex="0"
                      role="button"
                    >
                      Remove
                      <span class="icon">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 6H21"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </li>
                  }
                </ul>
              </div>
            }

            <input
              #fileInput
              type="file"
              (change)="onFileSelected($event)"
              accept=".jpg, .jpeg, .png, .heic, .heif"
              style="display: none"
            />
          </div>

          <div class="profile-info" id="tour-organization-details">
            <h1>
              {{
                userProfileDetails?.first_name && userProfileDetails?.last_name
                  ? userProfileDetails?.first_name +
                    " " +
                    userProfileDetails?.last_name
                  : userProfileDetails?.first_name ||
                    userProfileDetails?.last_name ||
                    user?.name ||
                    "-"
              }}
            </h1>
            <!-- <p class="connection-name">
            <svg
              width="16"
              height="16"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
            >
              <path
                d="M192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 128C512 92.7 483.3 64 448 64L192 64zM304 416L336 416C353.7 416 368 430.3 368 448L368 528L272 528L272 448C272 430.3 286.3 416 304 416zM224 176C224 167.2 231.2 160 240 160L272 160C280.8 160 288 167.2 288 176L288 208C288 216.8 280.8 224 272 224L240 224C231.2 224 224 216.8 224 208L224 176zM368 160L400 160C408.8 160 416 167.2 416 176L416 208C416 216.8 408.8 224 400 224L368 224C359.2 224 352 216.8 352 208L352 176C352 167.2 359.2 160 368 160zM224 304C224 295.2 231.2 288 240 288L272 288C280.8 288 288 295.2 288 304L288 336C288 344.8 280.8 352 272 352L240 352C231.2 352 224 344.8 224 336L224 304zM368 288L400 288C408.8 288 416 295.2 416 304L416 336C416 344.8 408.8 352 400 352L368 352C359.2 352 352 344.8 352 336L352 304C352 295.2 359.2 288 368 288z"
              />
            </svg>
            {{ user?.connection_display_name }}
          </p> -->
          </div>
        </div>

        @if (isSmeUser || isDHUser) {
          <button
            class="profile-edit-button"
            aria-label="Edit profile"
            (click)="onEditProfile()"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z"
                fill="currentColor"
              />
            </svg>

            Edit
          </button>
        }
      </div>
      @if (isSmeUser && !isProfileLoading) {
        <div class="details-grid" id="tour-profile-details">
          <div class="detail-item">
            <div class="detail-label">First Name</div>
            <div class="detail-value">
              {{ userProfileDetails?.first_name || "-" }}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">Last Name</div>
            <div class="detail-value">
              {{ userProfileDetails?.last_name || "-" }}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">Email</div>
            <div class="detail-value">
              {{ userProfileDetails?.email || "-" }}
            </div>
          </div>
        </div>
      }
    </div>

    <div class="profile-content">
      <div class="session-card" id="tour-email-preference">
        <div class="section-header">
          <h2>Email Preferences</h2>
          <p class="section-description">
            View your current email status and update your preferences to
            receive emails.
          </p>
        </div>

        <div class="email-preferences-content">
          <div class="email-info-row">
            <div class="email-label">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22 6L12 13L2 6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="email-address">{{ user?.email }}</span>
            </div>

            @if (loaderDnd) {
              <div class="skeleton skeleton-badge"></div>
            } @else {
              @if (dndEmail) {
                <span class="status-badge danger">
                  <span class="badge-icon">⛔</span>
                  Unsubscribed
                </span>
              } @else {
                <span class="status-badge success">
                  <span class="badge-icon">✔</span>
                  Subscribed
                </span>
              }
            }
          </div>

          @if (loaderDnd) {
            <div class="skeleton-group">
              <div class="skeleton skeleton-line w-full"></div>
              <div class="skeleton skeleton-line w-220"></div>
            </div>
          } @else if (!loadingDnd) {
            @if (dndEmail) {
              <div class="email-details-card">
                <div class="email-details-grid">
                  <div class="email-detail-item">
                    <span class="email-detail-label">Unsubscribed on</span>
                    <span class="email-detail-value">
                      {{ dndEmail.created_at_utc | date: "medium" }}
                    </span>
                  </div>
                  <div class="email-detail-item">
                    <span class="email-detail-label">Reason</span>
                    <span class="email-detail-value">{{
                      dndEmail.reason || "—"
                    }}</span>
                  </div>
                </div>

                <div class="info-message warning">
                  <span class="icon" aria-hidden="true">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="9"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M12 10V16"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <circle cx="12" cy="7" r="1" fill="currentColor" />
                    </svg>
                  </span>
                  <span class="text">
                    You are currently unsubscribed and will not receive
                    important updates.
                  </span>
                </div>

                <div class="button-wrapper">
                  <button
                    class="resume-btn"
                    [disabled]="loadingDnd"
                    (click)="onRemoveFromDnd()"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 11L12 14L22 4"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 12V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H16"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Resume Emails
                  </button>
                </div>
              </div>
            } @else {
              <div class="info-message success">
                <span class="icon">✔</span>
                <span class="text">
                  You will receive all important email updates.
                </span>
              </div>
            }
          }
        </div>
      </div>

      <div class="session-card">
        <div class="section-header">
          <h2>Session Details</h2>
          <p class="section-description">
            View your current session information and activity
          </p>
        </div>
        <app-session-details></app-session-details>
      </div>
    </div>
  }

  @if (activeTab === "cdfi-profile") {
    <app-cdfi-profile></app-cdfi-profile>
  }

  @if (showDeletePopup) {
    <app-popup
      [heading]="'Delete Profile Picture'"
      [confirmText]="'Delete'"
      [cancelText]="'Cancel'"
      (confirmClicked)="onConfirmDelete()"
      (cancelClicked)="onCancelDelete()"
    >
      <div class="popup-message">
        <p>Are you sure you want to delete your profile picture?</p>
      </div>
    </app-popup>
  }
</div>

@if (showProfileEditPopup) {
  <app-popup
    [heading]="'Edit Profile'"
    [confirmText]="'Save'"
    [cancelText]="'Cancel'"
    (confirmClicked)="saveProfileDetails()"
    (cancelClicked)="showProfileEditPopup = false"
  >
    <div class="profile-edit-form">
      <div class="field-group">
        <label for="firstName">
          First Name <span class="required">*</span>
        </label>

        <input
          id="firstName"
          type="text"
          [(ngModel)]="editFirstName"
          (ngModelChange)="onFirstNameChange()"
          placeholder="Enter first name"
        />

        @if (isFirstnameErr) {
          <div class="error-message">First name is required.</div>
        }
      </div>
      <div class="field-group">
        <label for="lastName">Last Name</label>

        <input
          id="lastName"
          type="text"
          [(ngModel)]="editLastName"
          placeholder="Enter last name"
        />
      </div>
    </div>
  </app-popup>
}
